import { Canvas } from "@react-three/fiber";
import CloudInstances from "./CloudInstances";
import { CameraControls } from "./CameraControls";

function Scene() {
  return (
    <div className="dreamland__canvas">
    <Canvas>
      <ambientLight intensity={3} />
      <CameraControls />
      <fog attach="fog" args={[0x775c88, 50, 100]} /> 
      <CloudInstances count={1000} /> 
    </Canvas>
    </div>
  );
}

export default Scene;
